require('../services/user-service.js');
require('../controllers/accept-privacy-policy-ctrl.js');


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/page-entries/accept-privacy-policy-entry.js
// module id = 477
// module chunks = 32